/**
 * Type definition for available filter operators that can be used in query filters.
 */
declare type FilterOperator =
  | 'search'
  | 'eq'
  | 'between'
  | 'gte'
  | 'lte'
  | 'is_not_true'
  | 'in'
  | 'like'
  | 'i_like'
  | 'noteq'
  | 'is_empty_num_id'
  | 'is_blank'
  | 'is_present'
  | 'is_not_false'
  | 'is_true'
  | 'is_false'
  | 'is_not_null'
  | 'is_null'
  | 'notin_with_null'
  | 'notin'
  | 'gt'
  | 'lt'
  | 'i_nlike'
  | 'nlike'

/**
 * Type definition for a query filter that can be applied to filter data.
 */
declare type QueryFilter = {
  name: string
  operator: FilterOperator
  value: any
}

/**
 * Type definition for sorting parameters that can be applied to sort data in a query.
 */
declare type QuerySorter = {
  name: string
  desc?: boolean
}

/**
 * Type definition for pagination parameters that can be applied to paginate query results.
 */
declare type QueryPaginator = {
  page?: number
  limit?: number
}

/**
 * A utility function to adjust query filters based on changes provided in `filtersChange`.
 *
 * @param {QueryFilter[]} filters - The current query filters.
 * @param {QueryFilter[]} filtersChange - The changes to be applied to the filters.
 * @param {boolean} replaceIf - A flag indicating whether to replace existing filters if a filter with the same name exists.
 * @returns {QueryFilter[]} The adjusted query filters.
 */
export function adjustFilters(
  filters: QueryFilter[],
  filtersChange: QueryFilter[],
  replaceIf: boolean = true
): QueryFilter[] {
  var filtersNew = [...filters]

  filtersChange.forEach(change => {
    const idx = (filtersNew || []).findIndex(f => f.name === change.name)
    if (idx !== -1 && !replaceIf) {
      return
    }
    idx !== -1 ? filtersNew.splice(idx, 1, change) : filtersNew.push(change)
  })

  return filtersNew
}
